const filterArrayNonNull = <T>(items: (T | null)[]): T[] =>
  items
    .filter((item) => item !== null && item !== undefined)
    .map((item) => item as T)

export default filterArrayNonNull
